export interface TenantStore {
  _id: string;
  code: string;
  name: string;
  address: string;
  phone?: string;
  managerId?: string;
  active: boolean;
  openingHours?: string;
}

export const mockStores: TenantStore[] = [
  {
    _id: 'store-01',
    code: 'CN01',
    name: 'Chi nhánh 1 — Q.1',
    address: '123 Đường Vàng, Q.1, TP.HCM',
    phone: '028 3822 0001',
    active: true,
  },
  {
    _id: 'store-02',
    code: 'CN02',
    name: 'Chi nhánh 2 — Q.5',
    address: '45 Nguyễn Trãi, Q.5, TP.HCM',
    phone: '028 3822 0002',
    active: true,
  },
  {
    _id: 'store-03',
    code: 'CN03',
    name: 'Chi nhánh 3 — Tân Bình',
    address: '78 Cộng Hoà, Tân Bình, TP.HCM',
    phone: '028 3822 0003',
    active: true,
  },
];
